import { Injectable } from '@angular/core';
import {  Http, Response, Headers} from '@angular/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
/*
Generat    createuserPetDetail(): any {
        throw new Error("Method not implemented.");
    }
ed class for the DoctorserviceProvider provider.

See https://angular.io/docs/ts/latest/guide/dependency-injection.html
for more info on providers and Angular DI.
*/

@Injectable()
export class DoctorService {
    private cdtk= "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjZlOWVlZDVjODQ5Yzk1YTVlNjIwYTUyMDMwMTYyMDJiOTBmYzAxNzRkMzA3NDc0OTc1ZmFlMDgyNDdkMGNhNjdiNmFhMzIzM2NmMjgyYjA0In0.eyJhdWQiOiIzIiwianRpIjoiNmU5ZWVkNWM4NDljOTVhNWU2MjBhNTIwMzAxNjIwMmI5MGZjMDE3NGQzMDc0NzQ5NzVmYWUwODI0N2QwY2E2N2I2YWEzMjMzY2YyODJiMDQiLCJpYXQiOjE1MzE0MDA3MjcsIm5iZiI6MTUzMTQwMDcyNywiZXhwIjoxNTYyOTM2NzI3LCJzdWIiOiIiLCJzY29wZXMiOltdfQ.dz0LSq7-jtxzrLmH6KgrNFGBYYq7UHf9n10owKt1JSoUdoLiCJJEmTprHufPiBrzu_6FxwivAUW5gD6yCQicAeVvxqBk1V3lNJduKt8TrCqeJWhqlECRvPp-fRJsbh3ZxsPwysKrAlb2AeWBv_NowO7nRyB4IpUiTatmV_Ud41WdM_pW-hBdJGLlX8-m5wHRYGOyMQay257byTtqOtJHVpouZd8b3Itta2uVX4cVaGgtTosebKfuLYG_xs5yLGMXXuab8pL2e5IdhYsYe1WJ0n-1qUK0ZH26WyLBZzEQ7s7DR3HGJN_YfBRLEDRmphvnYxBeAfiKtl1G4ztFSOksG5Qwxq-YugCODot_AmiNvUVxqRumgzegyx-xJN-Xc7ATbghFQ9iJwpLRiiqbQrFtsAe8eB6dLMpQ-mV4wFqZp51EQtAViW0LL9Rb9z1pghaMhBdurNyKCr5r-dMgI8fPAUd5iEQ8lloz-BJ_dowSiotHiPMNgpQOuQ_3lMKZyWs9UGxyCzCJ5g52Pe28Qvd8KLZ5uyI6pOQZNBRHGD0QRjn9erW3tDGDWx-Teba77YiLlpGjpX9zxbruEun0n3BlorGX7QEncW9riLorDC8OnWPNvgL1Iu1d1sEYYFKdfJETfrBCcrDWjexHWtbBtZZEthztq1wPiqbtOw5INiTjV6Q";
    clientcredentialheader = new Headers({'Content-Type':'application/json',
    'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest',
    'Authorization': this.getClientCredential()});
     authcredheader: any;
constructor(public http: Http,@Inject(PLATFORM_ID) private platformId: Object) {;
}
getClientCredential(){
    var Bearer= 'Bearer' + ' ' + this.cdtk;
    return Bearer;
  }
getAuthCredential(){
    if (isPlatformBrowser(this.platformId)) {
    var a = localStorage.getItem("token");
    var tjson =JSON.parse(a);
    if(tjson != null){
      var auth= 'Bearer' + ' ' +  tjson.token;
      return auth;
    }
}
  }
  genAuthHeader(){
    this.authcredheader = new Headers({'Content-Type':'application/json',
    'Accept':'application/json',
    'Authorization': this.getAuthCredential()})
  }
getDoctors(): Observable<any> {
    return this.http.get('https://passport.petcart.in/serviceproviders',
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}
getSpecialisation() {
    return this.http.get('https://passport.petcart.in/specialisation',
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}
getSpecialist(spec: number): Observable<any> {
    return this.http.get('https://passport.petcart.in/specialists?specialisation_id=' + spec,
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}
getDoctorsDetail(id: number) {
    return this.http.get('https://passport.petcart.in/serviceproviders?id=' + id,
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}
checkLeave(pid, date) {
    return this.http.get('https://passport.petcart.in/leavedays?serviceprovider_id=' + pid + '&date=' + date,
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}
getdoctorShedule(sid ,  day) {
    return this.http.get('https://passport.petcart.in/availschedule?serviceprovider_id=' + sid + '&day='+day,
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}

getdoctorScheduleByDate(sid, date){
    return this.http.post('https://passport.petcart.in/getdoctorschedulebydate',
    {date: date, serviceprovider_id: sid},
    {headers: this.clientcredentialheader})
   .pipe(map(
      (response: Response) =>{
       return response.json().data;
      })
      );
  }

getServiceMenu(spid){
    return this.http.get('https://passport.petcart.in/servicemenu?serviceprovider_id='+ spid,
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
         return response.json().data;
       })
    );
  }
bookingAppointment(pid, userid, dat, selectedslot, endtime, status, service_id, pet_id,
pstatus, pmode , clid, ip , source){
    this.genAuthHeader();
    return this.http.post('https://passport.petcart.in/appointments',
    {serviceprovider_id: pid,user_id:userid,date:dat,start_time:selectedslot,end_time:endtime,
      status:status,service_id:service_id,pet_id:pet_id , payment_status: pstatus,
    payment_mode: pmode, clinic_id: clid, ip: ip, source: source},
    {headers: this.authcredheader}
    )
  .pipe(map(
    (response: Response) => response.json().data
   ));
    }
createuserPetDetail(user_id, petname, pettype, dob, image, bio): Observable<any> {
    this.genAuthHeader();
    return this.http.post('https://passport.petcart.in/pets',
    {user_id: user_id, pet_name: petname, pet_type: pettype , dob: dob, image: image , bio: bio},
    {headers: this.authcredheader}
    )
    .pipe(map(
    (response: Response) => {
        return response.json().data;
    })
);
    }
    updateuserpetDetail(id, petname, pettype): Observable<any> {
    this.genAuthHeader();
    return this.http.put('https://passport.petcart.in/pets/' + id,
    {pet_name: petname, pet_type: pettype},
    {headers: this.authcredheader}
    )
    .pipe(map(
    (response: Response) => {
        return response.json().data;
    })
    );
    }
    uploadComments(bid, userid, comment) {
    return this.http.post('https://passport.petcart.in/comments',
    {blog_id: bid, user_id: userid , comment: comment},
    {headers: new Headers({'Content-Type': 'application/json'})}
    )
    .pipe(map(
    (response: Response) => {
        return response.json().data;
    })
);
    }
    uploadCommentsOnForum(bid, userid, comment) {
        status = 'approved';
        return this.http.post('https://passport.petcart.in/comments',
        {blog_id: bid, user_id: userid , comment: comment, status: status},
        {headers: new Headers({'Content-Type': 'application/json'})}
        )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
        }
    getCommentsOnBlog(bid): Observable<any> {
    return this.http.get('https://passport.petcart.in/comments?blog_id='+bid+'&status=approved&sort_bydesc=updated_at',
    {headers: new Headers({'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json'})})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
        );
    }
    getCommentedUserDetail(uid) {
        this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/users?id=' + uid,
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
        );
    }
    getForum(): Observable<any> {
    return this.http.get('https://passport.petcart.in/blogs?type=forum&sort_bydesc=updated_at&status=published')
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
    );
    }
    getForumDetail(bid): Observable<any> {
    return this.http.get('https://passport.petcart.in/blogs?id=' + bid,
    {headers: this.clientcredentialheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
    );
    }
    askAVet(title, body, url, image, type , category, pet_type, breed, life, uid) {
    return this.http.post('https://passport.petcart.in/blogs',
    {title: title, body: body, url: url, category: category,
    blogcoverimg: image, type: type, pet_type: pet_type, breed_id: breed,
     lifestage_id: life, user_id: uid},
    {headers: new Headers({'Content-Type': 'application/json'})}
    )
    .pipe(map(
    (response: Response) => {
        return response.json().data;
    })
);
    }
    getUserAppointment(uid): Observable<any> {
    this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/appointments?user_id=' + uid,
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
    return response.json().data;
        })
    );
    }
    getUserPetInfo(userid) {
        this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/pets?user_id=' + userid,
    {headers: this.authcredheader})
    .pipe(map(
    (response: Response) => {
        return response.json().data;
    })
);
    }
    deletePetDetail(id) {
        this.genAuthHeader();
    return this.http.delete('https://passport.petcart.in/pets/' + id,
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
    );
    }
    uploadUserpetDocument(pid , subject, type, path, apid) {
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/petdocument',
        {pet_id: pid, subject: subject, document_type: type, path: path, appointment_id: apid},
        {headers: this.authcredheader}
        )
      .pipe(map(
        (response: Response) => response.json().data
       ));
      }
    getUploadDocument(pid) {
        this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/petdocument?pet_id=' + pid,
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
    );
    }
    checkOnlineServiceprovider() {
        return this.http.get('https://passport.petcart.in/onlinedocs',
        {headers: this.clientcredentialheader})
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
    }
    getBlogs(): Observable<any> {
        const type = 'blog';
        return this.http.get('https://passport.petcart.in/blogs?type=' + type,
        {headers: this.clientcredentialheader})
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
        );
    }
    getBogDetail(bid): Observable<any> {
        return this.http.get('https://passport.petcart.in/blogs?id=' + bid,
        {headers: this.clientcredentialheader})
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
        );
    }
    getChatDetail(): Observable<any>{
        return this.http.get('https://passport.petcart.in/onlinedocs',
        {headers: this.clientcredentialheader})
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
    }
    getDoctorPage(): Observable<any> {
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/users',
        {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
        );
    }

    getAppointmentWithMe(spid): Observable<any> {
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/appointments?serviceprovider_id=' + spid,
        {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
        );
    }

    postOnline(sid) {
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/onlinedocs',
        {serviceprovider_id: sid},
        {headers: this.authcredheader}
        )
        .pipe(map(
        (response: Response) => response.json().data
        ));

}
deleteOnline(id: number) {
    this.genAuthHeader();
return this.http.delete('https://passport.petcart.in/onlinedocs/' + id,
{headers: this.authcredheader})
    .pipe(map(
    (response: Response) => {
    return response.json().data
    }) );
}
userId(sid: number): Observable<any> {
    return this.http.get('https://passport.petcart.in/onlinedocs?serviceprovider_id=' + sid,
    {headers: this.clientcredentialheader})
    .pipe(map(
    (response: Response) => {
        return response.json().data;
    })
    );
}
getDocsTable():  Observable<any> {
    return this.http.get('https://passport.petcart.in/availschedule',
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}

updateMyDaySchedule(id, stime, etime, sduration) {
    this.genAuthHeader();
            return this.http.put('https://passport.petcart.in/availschedule/' + id,
              {start_time: stime, end_time: etime, slotduration: sduration },
              {headers: this.authcredheader})
            .pipe(map(
            (response: Response) => {
            return response.json().data;
            })
            );
        }
        verifyDoctorEmail(email: String): Observable<any> {
            this.genAuthHeader();
            return this.http.get('https://passport.petcart.in/users?email=' + email,
            {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
            return response.json().data;
            })
            );
        }
        getServiceproviderownId(userid) {
            return this.http.get('https://passport.petcart.in/serviceproviders?user_id=' + userid,
            {headers: this.clientcredentialheader})
        .pipe(map(
            (response: Response) => {
            return response.json().data;
            })
        ); }
            checkOwnLoginstatus(spid) {
                return this.http.get('https://passport.petcart.in/onlinedocs?serviceprovider_id=' + spid,
                {headers: this.clientcredentialheader})
            .pipe(map(
                (response: Response) => {
                return response.json().data;
                })
            );
             }
                getAppointmentDetail(appointid) {
                    this.genAuthHeader();
                    return this.http.get('https://passport.petcart.in/appointments?id=' + appointid,
                    {headers: this.authcredheader})
                .pipe(map(
                    (response: Response) => {
                    return response.json().data;
                    })
                    );
                }
    getAppointmentmentUserDetail(sid) {
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/users?id=' + sid,
        {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
        );
    }
    cancelAppointment(id) {
        const status = 4;
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/appointments/' + id,
        {status: status},
        {headers: this.authcredheader})
         .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
    }


    getMyExistingShedule(spid) {
        return this.http.get('https://passport.petcart.in/availschedule?serviceprovider_id=' + spid,
        {headers: this.clientcredentialheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
        );
    }
    addDaySchedule(spid, day, stime , etime , sd, clid) {
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/availschedule',
        {serviceprovider_id: spid, day: day, start_time: stime, end_time: etime, slotduration: sd,
        clinic_id:clid},
        {headers: this.authcredheader}
        )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
    }
    deleteSchedule(id) {
        this.genAuthHeader();
        return this.http.delete('https://passport.petcart.in/availschedule/' + id,
        {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
            return response.json().data;
            })
        );
    }
    getMyLeaves(spid) {
        return this.http.get('https://passport.petcart.in/leavedays?serviceprovider_id=' + spid ,
        {headers: this.clientcredentialheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
        );
    }
    confirmMyLeave(spid, ld, cidstr) {
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/leavedays',
        {serviceprovider_id: spid, date: ld, clinicid: cidstr},
        {headers: this.authcredheader}
        )
    .pipe(map(
        (response: Response) => response.json().data
    ));
    }
    canecellLeave(id) {
        this.genAuthHeader();
        return this.http.delete('https://passport.petcart.in/leavedays/' + id,
        {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
            return response.json().data;
            })
        );
    }
    createUser(name: string, email: string, mobile: string, bio: string, image: string,
        gender: string, role_id: number,
        dob: string, remember_token: string, password: number, ip, sr) {
        return this.http.post('https://passport.petcart.in/register',
            {name: name, email: email, mobile: mobile, bio: bio, gender: gender,
                role_id: role_id, dob: dob, remember_token:
            remember_token, password: password, image: image, ip: ip, source: sr},
            {headers: this.clientcredentialheader})
            .pipe(map((response: Response) => {
              const token = response.json() && response.json().token;
              if (token) {
                  return true;
              }
              if (!token) {
                  return false;
              }
          })
        );
    }
        registerPatientWithUs(uid , guid) {
            this.genAuthHeader();
          return this.http.post('https://passport.petcart.in/registerpatient',
          {doctor_id: uid, register_user_id: guid},
          {headers: this.authcredheader})
          .pipe(map((response: Response) => {
            return response.json().data;
        })
    );
        }
        getMyData(email) {
            this.genAuthHeader();
            return this.http.get('https://passport.petcart.in/users?email=' + email,
        {headers: this.authcredheader})
           .pipe(map(
               (response: Response) => {
               return response.json().data;
           })
           );
          }
          getdataByMobile(mob) {
              this.genAuthHeader();
            return this.http.get('https://passport.petcart.in/users?mobile=' + mob,
            {headers: this.authcredheader})
            .pipe(map(
                (response: Response) => {
                return response.json().data;
            })
            );
          }
          checkAlreadyTagged(uid, did) {
              this.genAuthHeader();
            return this.http.get('https://passport.petcart.in/registerpatient?doctor_id=' + did +'&user_id=' + uid,
            {headers: this.authcredheader})
            .pipe(map((response: Response) => {
              return response.json().data;
          })
        );
          }
          getAllMyRegisterPatient(uid) {
              this.genAuthHeader();
            return this.http.get('https://passport.petcart.in/registerpatient?doctor_id=' + uid ,
            {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
            return response.json().data;
            })
            );
        }
        getTime() {
            return this.http.get('https://passport.petcart.in/time',
            {headers: this.clientcredentialheader})
            .pipe(map(
              (response: Response) => {
               return response.json();
              })
              );
          }
          cancellAppointment(apid) {
              this.genAuthHeader();
            return this.http.put('https://passport.petcart.in/appointments/' + apid,
          {status: 'cancelled'},
          {headers: this.authcredheader})
            .pipe(map(
               (response: Response) => {
                return response.json().data;
               })
               );
          }
          getService(sid) {
            return this.http.get('https://passport.petcart.in/services/' + sid,
            {headers: this.clientcredentialheader})
            .pipe(map(
              (response: Response) => {
               return response.json().data;
              })
              );
          }


          getparticulerPetdetail(pid) {
              this.genAuthHeader();
              return this.http.get('https://passport.petcart.in/pets/' + pid,
              {headers: this.authcredheader})
            .pipe(map(
              (response: Response) => {
               return response.json().data;
              })
              );
    }

    getAllPets() {
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/pets',
        {headers: this.authcredheader})
      .pipe(map(
        (response: Response) => {
         return response.json().data;
        })
        );
     }

     getAllDummyUser(): Observable<any> {
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/dummyusers',
        {headers: this.authcredheader})
        .pipe(map(
        (response: Response) => {
          return response.json().data;
        })
    );
        }

    gePetAppointment(pid) {
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/appointments?pet_id=' + pid,
        {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
        return response.json().data;
            })
        );
    }
    updatepetimage(pid, file ) {
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/pets/' + pid,
        {image: file},
        {headers: this.authcredheader}
        )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
    }
    getRecentBlogs(): Observable<any> {
        const type = 'blog';
        return this.http.get('https://passport.petcart.in/blogs?type=blog&sort_bydesc=updated_at',
        {headers: this.clientcredentialheader} )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
        );
    }
    getAllServicess() {
        return this.http.get('https://passport.petcart.in/services',
        {headers: this.clientcredentialheader})
        .pipe(map(
          (response: Response) => {
          return response.json().data;
           })
        );
    }
    getAllServices(serviceid) {
        return this.http.get('https://passport.petcart.in/services?id=' + serviceid,
        {headers: this.clientcredentialheader})
        .pipe(map(
          (response: Response) => {
          return response.json().data;
           })
        );
      }
    getallBreeds() {
        return this.http.get('https://passport.petcart.in/breeds',
        {headers: this.clientcredentialheader} )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
    }
    getCategoryBlogs(cid) {
        return this.http.get('https://passport.petcart.in/blogs?type=blog&category=' + cid,
        {headers: this.clientcredentialheader}  )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
        );
    }
    getBlogsByBreed(cid) {
        return this.http.get('https://passport.petcart.in/blogs?type=blog&breed_id=' + cid,
        {headers: this.clientcredentialheader} )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
        );
    }
    getBlogsByLifestage(cid) {
        return this.http.get('https://passport.petcart.in/blogs?type=blog&lifestage_id=' + cid,
        {headers: this.clientcredentialheader} )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
        );
    }
    getBlogsByPettype(cid) {
        return this.http.get('https://passport.petcart.in/blogs?type=blog&pet_type=' + cid,
        {headers: this.clientcredentialheader} )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
        );
    }

    getMyChat(id) {
    return this.http.get('https://petcart.in:8085/v1/live-channels/?externalUserId=' + id)
    .pipe(map(
        (response: Response) => {
            return response.json()
        })
    );
    }
    getServiceMenus(sid) {
        return this.http.get('https://passport.petcart.in/servicemenu?serviceprovider_id=' + sid,
        {headers: this.clientcredentialheader})
        .pipe(map(
            (response: Response) => {
                return response.json().data;
            })
        );
    }
    getAllSpecialisation() {
        return this.http.get('https://passport.petcart.in/specialisation',
        {headers: this.clientcredentialheader})
        .pipe(map(
            (response: Response) => {
                return response.json().data;
            })
        );
    }
    GetMyAvailableSpecialisation(sid) {
        return this.http.get('https://passport.petcart.in/specialists?serviceprovider_id=' + sid,
        {headers: this.clientcredentialheader})
        .pipe(map(
            (response: Response) => {
                return response.json().data;
            })
        );
    }
    deleteMyService(id) {
        this.genAuthHeader();
        return this.http.delete('https://passport.petcart.in/servicemenu/' + id,
        {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
                return response.json().data;
            })
        );
    }
    editFees(sid, fees) {
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/servicemenu/' + sid,
        {fees: fees}, {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
                return response.json().data;
            })
        );
    }
    addMyService(spid, sid, fees) {
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/servicemenu',
        { service_id: sid, serviceprovider_id: spid , fees: fees},
         {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
                return response.json().data;
            })
        );
    }
    deleteMySpecialisation(id) {
        this.genAuthHeader();
        return this.http.delete('https://passport.petcart.in/specialists/' + id,
        {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
                return response.json().data;
            })
        );
    }
    addMySpecialisation(id, spid) {
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/specialists',
        { serviceprovider_id: spid, specialisation_id: id},
        {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
                return response.json().data;
            })
        );
    }
    changeMyprofile(name, address, mobile, email, about, qualification, experience,
         education, expdetails, registration, awards, membership, id) {
             this.genAuthHeader();
            return this.http.put ('https://passport.petcart.in/serviceproviders/' + id,
        {name: name, address: address, mobile: mobile, email: email,
        about: about, qualification : qualification, experience: experience,
        education: education, expdetails: expdetails, registration: registration,
        awards: awards, membership : membership },
        {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
                return response.json().data;
            })
        );
    }
    getdoctorAppointment(sid, date) {
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/appointments?serviceprovider_id='+sid+'&date='+date+
        '&payment_status=complete',
        {headers: this.authcredheader})
       .pipe(map(
          (response: Response) => {
         return response.json().data;
          })
          );
      }
      updateAppointmentPayment(id, stat , status ) {
          this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/appointments/' + id,
        {payment_status: stat, status: status},
        {headers: this.authcredheader})
       .pipe(map(
          (response: Response) => {
         return response.json().data;
          })
          );
      }
      checkDoctorAvailablity(id) {
        return this.http.get('https://passport.petcart.in/onlinedocs?serviceprovider_id=' + id,
        {headers: this.clientcredentialheader})
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
      }
      getAppointmentTaggedDocuments(apid) {
          this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/petdocument?appointment_id=' + apid,
        {headers: this.authcredheader})
        .pipe(map(
            (response: Response) => {
            return response.json().data;
            })
        );
      }
      AcceptChatRequest(id, status){
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/chatrequests/' + id,
        {status: status},
        {headers: this.authcredheader}
        )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
      }
      RejectChatRequest(id, status){
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/chatrequests/' + id,
        {status: status},
        {headers: this.authcredheader}
        )
        .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
      }


      postChatRequests(user_id,sid,status){
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/chatrequests',
        {user_id:user_id,serviceprovider_id: sid, status: status},
        {headers: this.authcredheader}
        )
      .pipe(map(
        (response: Response) => {
          return response.json().data;
         })
        );
      }

      getServiceproviderId(id:number){
        return this.http.get('https://passport.petcart.in/serviceproviders?user_id='+id,
        {headers: this.clientcredentialheader})
       .pipe(map(
          (response: Response) =>{
           return response.json().data;
          })
          );
      }
      sendNotificationRequestToUser(ownuid, userid, category, message,
        email,sms,pushmessage,status){
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/doctornotificationrequest',
        {spuser_id: ownuid, user_id:userid,category:category,message:message,email:email,
          status:status,sms:sms,push:pushmessage},
         {headers: this.authcredheader}
        )
      .pipe(map(
        (response: Response) => response.json().data
       ));
      }
      getClinic(){
        return this.http.get('https://passport.petcart.in/clinic',
        {headers: this.clientcredentialheader})
       .pipe(map(
          (response: Response) =>{
           return response.json().data;
          })
          );
      }
      getMyRegisterClinic(spid){
        return this.http.post('https://passport.petcart.in/doctormappingclinic',
        {serviceprovider_id: spid},
        {headers: this.clientcredentialheader})
       .pipe(map(
          (response: Response) =>{
           return response.json().data;
          })
          );
      }
      getMyLeavemapping(lid){
        return this.http.post('https://passport.petcart.in/leavedaysmap',
        {leave_id:lid},
        {headers: this.clientcredentialheader})
       .pipe(map(
          (response: Response) =>{
           return response.json();
          })
        );
      }


getBasicConsultation(){
var basiccons= "Basic Consultation";
  return this.http.get('https://passport.petcart.in/services?name='+ basiccons,
      {headers: this.clientcredentialheader})
         .pipe(map(
            (response: Response) => {
             return response.json().data;
            })
        );
}

getFees(rofapp, pid){
return this.http.get('https://passport.petcart.in/servicemenu?service_id='+ rofapp +'&&serviceprovider_id='+ pid,
{headers: this.clientcredentialheader})
.pipe(map(
(response: Response) => {
return response.json().data;
})
);
}
updateServiceproviderImage(id, image): Observable<any> {
this.genAuthHeader();
return this.http.put('https://passport.petcart.in/serviceproviders/' + id,
{photo: image},
{headers: this.authcredheader}
)
.pipe(map(
(response: Response) => {
return response.json().data;
})
);
}

getMyTodaysClinic(spid) {
return this.http.post('https://passport.petcart.in/getmytodaysclinic',
{serviceprovider_id: spid},
{headers: this.clientcredentialheader})
.pipe(map(
  (response: Response) => {
   return response.json().data;
  })
  );
}

getToaysWalkin(spid){
return this.http.post('https://passport.petcart.in/todayswalkin',
{spid: spid},
{headers: this.clientcredentialheader})
.pipe(map(
  (response: Response) =>{
   return response.json().data;
  })
);
}
getNextAppointment(clid,spid){
return this.http.post('https://passport.petcart.in/nextappointment',
{spid:spid,clinic_id:clid},
{headers: this.clientcredentialheader})
.pipe(map(
  (response: Response) =>{
   return response.text();
  })
);
}
getTodaysAppointmentWithMe(spid){
return this.http.post('https://passport.petcart.in/todaysappointments',
{spid: spid},
{headers: this.authcredheader})
.pipe(map(
(response: Response) => {
return response.json().data;
})
);
}

updateAppointmentStatus(id, status) {
console.log(id, status);
this.genAuthHeader();
return this.http.put('https://passport.petcart.in/appointments/' + id,
{status: status},
{headers: this.authcredheader})
 .pipe(map(
(response: Response) => {
    return response.json().data;
})
 );
}

updateClinicWalkinStatus(id, status) {
console.log(id, status);
return this.http.put('https://passport.petcart.in/clinicwalkin/' + id,
{status: status},
{headers: this.clientcredentialheader})
 .pipe(map(
(response: Response) => {
    return response.json().data;
})
 );
}

getServices(){
return this.http.get('https://passport.petcart.in/services',
{headers: this.clientcredentialheader})
.pipe(map(
  (response: Response) => {
    return response.json().data;
   })
);
}

getAllAppointments(){
this.genAuthHeader();
return this.http.get('https://passport.petcart.in/appointments',
{headers: this.authcredheader})
.pipe(map(
  (response: Response) =>{
   return response.json().data;
  })
  );
}

getTotalAppointments() {
return this.http.get('https://passport.petcart.in/gettotalappointments',
{headers: this.clientcredentialheader})
.pipe(map(
  (response: Response) => {
   return response.json();
  })
  );
}

getAllChats(){
return this.http.get('https://passport.petcart.in/gettotalchats',
{headers: this.clientcredentialheader})
.pipe(map(
  (response: Response) =>{
   return response.json();
  })
  );
}

}
